import { Stack, Card, CardHeader, CardContent, IconButton, Box } from '@mui/material';
import {
    BoxSpaceBetween,
} from '../style/box'
import { FONT_COLOR } from '../const/general'

export default function CommonCard(props) {
    return (
        <Card variant="outlined"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#000',
                width: '100%',
                height: '100%',
                // heightの指定がない場合は、親（Stack）の残りの高さを埋める
                flexGrow: props.height ? 0 : 1
            }}>
            <CardHeader sx={{ padding: '3px' }}
                titleTypographyProps={{
                    sx: {
                        color: FONT_COLOR,
                        fontSize: {xs:'0.75rem',sm:'0.75rem', md:'clamp(0.375rem, -0.3rem + 1.2vw, 0.75rem)'},
                        fontWeight: 'bold',
                        backgroundColor: 'transparent',
                        padding: '3px',
                    }  
                }}
                title={props.title}
            />
            <CardContent
                sx={{
                    flex: 1, // ← これで残り全部使う
                    overflow: 'hidden', // はみ出し防止
                    padding: '0 5px',
                    '&:last-child': {
                        paddingBottom: '5px',
                    }
                }}
            >
                <Box
                    sx={{
                        boxSizing: 'border-box',
                        // height: '100%'
                        height: { xs: props.xsHeight, sm: props.height ?? '100%' }
                    }}>
                    {props.child}
                </Box>
            </CardContent>
        </Card>
    )
};
